import isPropValid from '@emotion/is-prop-valid'

export const isEmotionPropValid =
  (...customProps: string[]) =>
  (prop: string) =>
    isPropValid(prop) || customProps.includes(prop)
